//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/PropIdAreaId.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/PropIdAreaId.proto.
 */
export const file_android_hardware_automotive_vehicle_PropIdAreaId: GenFile = /*@__PURE__*/
  fileDesc("CjZhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9Qcm9wSWRBcmVhSWQucHJvdG8SKWFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvIjAKDFByb3BJZEFyZWFJZBIPCgdwcm9wX2lkGAEgASgFEg8KB2FyZWFfaWQYAiABKAViBnByb3RvMw");

/**
 * @generated from message android.hardware.automotive.vehicle.proto.PropIdAreaId
 */
export type PropIdAreaId = Message<"android.hardware.automotive.vehicle.proto.PropIdAreaId"> & {
  /**
   * @generated from field: int32 prop_id = 1;
   */
  propId: number;

  /**
   * @generated from field: int32 area_id = 2;
   */
  areaId: number;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.PropIdAreaId.
 * Use `create(PropIdAreaIdSchema)` to create a new message.
 */
export const PropIdAreaIdSchema: GenMessage<PropIdAreaId> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_PropIdAreaId, 0);

